import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Filter } from '../constants/types';

const serializeFilter = (filter: Filter) => {
  const encodedAttrs = filter.attributes.map(a => a.value).toString();
  const listable = filter.listable ? 'true' : 'false';
  const is_editable = filter.is_editable ? 'true' : 'false';
  const singleton = filter.singleton ? 'true' : 'false';
  const advancedOptions = filter.advancedOptions ? JSON.stringify(filter.advancedOptions) : '';
  const flatFilter = {
    ...filter,
    attributes: encodedAttrs,
    listable,
    is_editable,
    singleton,
    advancedOptions,
  };

  return new URLSearchParams(flatFilter).toString();
};

const deserializeFilter = (serializedFilter: string) => {
  const encodedFilterObj = Object.fromEntries(new URLSearchParams(serializedFilter));
  const decodedAttrs = decodeURIComponent(encodedFilterObj.attributes)
    .split(',')
    .map(value => ({ value }));
  return {
    ...encodedFilterObj,
    attributes: decodedAttrs,
    listable: encodedFilterObj.listable === 'true',
    is_editable: encodedFilterObj.is_editable === 'true',
    singleton: encodedFilterObj.singleton === 'true',
    advancedOptions: encodedFilterObj.advancedOptions ? JSON.parse(encodedFilterObj.advancedOptions) : undefined,
  } as Filter;
};

const useAttributeFilters = () => {
  const history = useHistory();
  const { search } = useLocation();
  const [attributeFilters, setAttributeFilters] = useState<Filter[]>([]);

  const setAttributeFiltersInUrl = (filters: Filter[]) => {
    const newQueryParams = new URLSearchParams();
    filters.forEach(filter => newQueryParams.append(filter.name, serializeFilter(filter)));
    history.push({
      search: newQueryParams.toString(),
    });
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const newAttrFilters: Filter[] = [];
    queryParams.forEach(serializedFilter => {
      newAttrFilters.push(deserializeFilter(serializedFilter));
    });
    setAttributeFilters(newAttrFilters);
  }, [search]);

  return { isFiltering: search.length > 0, attributeFilters, setAttributeFiltersInUrl };
};

export default useAttributeFilters;
